import React from 'react';

export const WrongIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" {...props}>
        <title>WrongIcon</title>
        <path
            fill="currentColor"
            stroke="currentColor"
            strokeLinejoin="round"
            d="M19.69.65a.5.5 0 00-.71 0L11 8.63 3.02.65a.5.5 0 00-.7 0L.64 2.3a.5.5 0 000 .71L8.63 11 .65 18.98a.5.5 0 000 .7l1.66 1.67c.2.2.51.2.71 0L11 13.37l7.98 7.98c.2.2.51.2.7 0l1.67-1.66a.5.5 0 000-.71L13.37 11l7.98-7.98a.5.5 0 000-.7L19.7.64z"
        />
    </svg>
);
